import styled, { createGlobalStyle } from 'styled-components'

export const CalendarWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  background-color: white;
  padding: 16px 24px;
  border-radius: 10px;
  min-height: 500px;
  box-sizing: border-box;
  overflow-x: auto;

  @media screen and (max-width: 576px) {
    padding: 12px;
    min-height: 420px;
    border-radius: 8px;
  }
`

export const ToolbarRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const ToolbarNav = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;

  @media screen and (max-width: 576px) {
    width: 100%;
    justify-content: space-between;
  }
`

export const ToolbarLabel = styled.span`
  margin-left: 16px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  @media screen and (max-width: 576px) {
    margin-left: 0;
    flex: 1 1 100%;
    width: 100%;
    text-align: center;
    order: -1;
    font-size: 1rem;
    padding: 4px 0 8px;
    white-space: normal;
  }
`

export const ToolbarSearch = styled.div`
  max-width: 350px;
  margin-top: 10px;
  margin-right: 10px;
  margin-left: auto;

  @media screen and (max-width: 576px) {
    max-width: none;
    width: 100%;
    margin: 0;

    input {
      width: 100% !important;
    }
  }
`

export const ToolbarViews = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  @media screen and (max-width: 576px) {
    width: 100%;
    justify-content: stretch;

    button {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`

export const CustomCalendarGlobalStyle = createGlobalStyle`
  .rbc-header {
    color: #0066B3 !important;
  }
  .calendar-view-btn {
    color: #fff !important;
    border: 1px solid #0066B3 !important;
    background: #0066B3 !important;
    font-weight: 500;
    transition: background 0.2s;
  }
  .calendar-view-btn:hover {
    background: #4d9de0 !important;
    border: 1px solid #4d9de0 !important;
  }
  .calendar-view-btn.rbc-active {
    background: #4d9de0 !important;
    color: #fff !important;
    border: 1px solid #4d9de0 !important;
  }
  .calendar-view-btn:active, .calendar-view-btn:focus {
    background: #4d9de0 !important;
    border: 1px solid #4d9de0 !important;
    color: #fff !important;
  }
  .calendar-today-btn {
    color: #fff !important;
    border: 1px solid #0066B3 !important;
    background: #0066B3 !important;
    font-weight: 500;
    transition: background 0.2s;
  }
  .calendar-today-btn:hover {
    background: #4d9de0 !important;
    border: 1px solid #4d9de0 !important;
  }
  .rbc-month-row {
    min-height: 75px !important;
  }
  .rbc-date-cell {
    height: 100% !important;
  }
  .rbc-off-range-bg {
    min-height: 100%;
    height: 100% !important;
    background: #f8f9fa !important;
  }

  @media screen and (max-width: 576px) {
    .rbc-month-row {
      min-height: 56px !important;
    }
    .rbc-toolbar {
      margin-bottom: 12px !important;
    }
    .rbc-header {
      font-size: 11px !important;
      padding: 4px 2px !important;
    }
  }
  
  .rbc-overlay {
    position: absolute !important;
    z-index: 1000 !important;
    background: white !important;
    border: 1px solid #ddd !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    max-width: 240px !important;
    width: 240px !important;
    height: 128px !important;
    max-height: 128px !important;
    overflow: hidden !important;
  }
  
  .rbc-overlay-header {
    padding: 6px 12px !important;
    background: #f8f9fa !important;
    border-bottom: 1px solid #e9ecef !important;
    border-radius: 8px 8px 0 0 !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #5F2AB2 !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  .rbc-overlay-event {
    padding: 6px 12px !important;
    border-bottom: 1px solid #f1f3f4 !important;
    cursor: pointer !important;
    transition: background-color 0.2s !important;
    height: 24px !important;
    display: flex !important;
    align-items: center !important;
    flex-shrink: 0 !important;
    overflow: hidden !important;
  }
  
  .rbc-overlay-event:last-child {
    border-bottom: none !important;
  }
  
  .rbc-overlay-event:hover {
    background-color: #f8f9fa !important;
  }
  
  .rbc-overlay-event .rbc-event-content {
    font-size: 12px !important;
    line-height: 1 !important;
    color: #333 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    height: 12px !important;
    display: block !important;
    max-width: 100% !important;
  }
  
  .rbc-overlay-event span {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    display: block !important;
    max-width: 100% !important;
  }
`
